import React, { FC } from "react";
import cn from "classnames";
import { Theme } from "src/@types/blog";
import { IBlogCard } from "./types";
import { stripHtml } from "src/utils/stripHtml";
import { formatDate } from "src/utils/formatDate";

interface Props extends Omit<IBlogCard, "id"> {
  className?: string;
}

export const BlogCard: FC<Props> = ({
  title,
  description,
  date,
  background_image,
  theme = Theme.LIGHT,
  className,
}) => {
  const plainDescription = stripHtml(description);
  const formattedDate = formatDate(date);

  return (
  <div
    className={cn(
      "h-52 px-5 pt-6 lg:max-w-133 lg:h-80 lg:px-11 lg:pt-13.75 pb-8 relative z-10 bg-blue-light rounded-2xl overflow-hidden",
      { "bg-green-dark": theme === Theme.DARK },
      { "lg:pt-11": background_image },
      className
    )}
  >
    {background_image && (
      <img
        src={background_image}
        alt=""
        className="absolute top-0 left-0 w-full h-full object-cover object-center -z-10"
      />
    )}

    <div
      className={cn(
        "flex flex-col gap-3 lg:gap-5 mb-5 md:mb-12 text-green-dark",
        {
          "!text-white-base": theme === Theme.DARK,
          "bg-white-base bg-opacity-70 rounded-2xl p-2 !mb-1 md:!mb-8":
            background_image && theme === Theme.LIGHT,
          "bg-green-dark bg-opacity-70 rounded-2xl p-2 !mb-1 md:!mb-8":
            background_image && theme === Theme.DARK,
        }
      )}
    >
      <h4
        className="text-lg max-w-44 xs:max-w-72 lg:max-w-102 lg:text-2xl truncate"
        title={title}
      >
        {title}
      </h4>

      <p className="text-xs max-w-102 lg:text-base line-clamp-4 3xl:line-clamp-5">
        {plainDescription}
      </p>
    </div>

    <div
      className={cn(
        "text-10 max-w-16 lg:max-w-24 lg:text-sm text-green-dark truncate",
        {
          "!text-white-base": theme === Theme.DARK,
          "bg-white-base bg-opacity-70 rounded-2xl p-1 lg:p-2":
            background_image && theme === Theme.LIGHT,
          "bg-green-dark bg-opacity-70 rounded-2xl p-1 lg:p-2":
            background_image && theme === Theme.DARK,
        }
      )}
      title={formattedDate}
    >
      {formattedDate}
    </div>
  </div>
  );
};
